var PaymentController = (function () {
    function PaymentController(topic) {
        this.topic = topic;
        this.OPP_VERSION_3 = 3;
    }
    PaymentController.$inject = ['topic'];
    return PaymentController;
}());
angular
    .module('application')
    .component('payment', new PaymentComponent());

//# sourceMappingURL=paymentController.js.map
